export default __webpack_public_path__ + "static/media/landing-credit-lift.b13e49bc.png";